/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Sold_Before_AfterInputs */

const en_cargos_sold_before_after = /** @type {(inputs: Cargos_Sold_Before_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sold (Before → After)`)
};

const es_cargos_sold_before_after = /** @type {(inputs: Cargos_Sold_Before_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendidas (Antes → Despues)`)
};

/**
* | output |
* | --- |
* | "Sold (Before → After)" |
*
* @param {Cargos_Sold_Before_AfterInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_sold_before_after = /** @type {((inputs?: Cargos_Sold_Before_AfterInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Sold_Before_AfterInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_sold_before_after(inputs)
	return es_cargos_sold_before_after(inputs)
});